/**
 * Leave lifecycle system-message kinds.
 *
 * The backend fans these out as `message_type: 'system'` rows into EVERY
 * conversation the on-leave user belongs to (DMs + groups + channels). They
 * render in-thread as a pill (see SystemMessagePill), but must NOT be treated
 * like a normal message: they must not become a conversation's last-message
 * preview, bump it to the top of the sidebar, or raise unread counts — doing so
 * floods the list with the same "<name> is on leave / is back" line everywhere.
 */
export const LEAVE_SYSTEM_KINDS = [
  'leave_start',
  'leave_end',
  'leave_approved',
  'leave_cancelled',
  'away_start',
  'away_end',
] as const;

export function isLeaveSystemMessage(
  msg: { message_type?: string; body?: unknown } | null | undefined
): boolean {
  if (!msg || msg.message_type !== 'system') return false;
  const kind = (msg.body as { kind?: string } | null | undefined)?.kind;
  return !!kind && (LEAVE_SYSTEM_KINDS as readonly string[]).includes(kind);
}

export function shouldRenderInMessageTimeline(
  msg: { message_type?: string; body?: unknown } | null | undefined
): boolean {
  return true;
}
